

const config = {
  baseUrl: process.env.REACT_APP_BASE_URL_724 || 'https://472.bodecom.com',
  excelProyectosPorOrganizaciones: process.env.REACT_APP_EXCEL_PROYECTOS_POR_ORGANIZACIONES_724 || 'https://472.bodecom.com',
  baseDirUrl: '/var/www/472/backend/Documentos724/DocumentosPOA/actividad_41/tarea_414/indicador_73/medio_verificacion_68',
  baseDirEstructuracion: process.env.REACT_BASE_ESTRUCTURACION_URL || '/Volumes/bodecom/prosperidad/backend/Documentos724/DocumentosPOA/actividad_13',
};
export default config;

/*
const config = {
  baseUrl: process.env.REACT_APP_API_URL,
  excelProyectosPorOrganizaciones:
    process.env.REACT_APP_EXCEL_PROYECTOS_POR_ORGANIZACION_724 || "",
  baseDirUrl: process.env.REACT_APP_BASE_DIR_URL_724 || "",
  baseDirEstructuracion:
    process.env.REACT_APP_BASE_ESTRUCTURACION_URL || "",
};

export default config;
*/
